/**
 * EngineerPhoto - an engineer's picture, or `fallback` (their initials) while
 * there is none, it is still loading, or it would not load. The bytes come
 * through hooks/useEngineerPhoto (the list carries only a version).
 */
import { useState } from 'react';
import { useEngineerPhoto } from '../../hooks/useEngineerPhoto';

const FILL = { width: '100%', height: '100%', objectFit: 'cover', display: 'block' };

export default function EngineerPhoto({ engineer, alt = '', fallback = null, style }) {
  const src = useEngineerPhoto(engineer);
  const [broken, setBroken] = useState('');
  if (!src || broken === src) return fallback;
  return <img src={src} alt={alt} style={{ ...FILL, ...style }} onError={() => setBroken(src)} />;
}
